import invariant from 'invariant';
import { createSlice } from '@reduxjs/toolkit';
import { LOAD_COUNTRIES_SUCCESS } from './index.js';
export { REDUX_AND_SAGA_KEY } from './index.js';
import '@dbh/reselect-extra';
import 'reselect';
import '@dbh/routing-redux';
import 'prop-types';
import '@dbh/lodash-extra';
import '@dbh/with-conforms-to-for-production-www';

const initialState={countries:{},countriesLoaded:{},error:void 0,isError:!1},countriesSlice=createSlice({name:"countries",initialState,reducers:{/**
     * Dispatched when the countries are loaded by the request saga.
     * @param {Object} state .
     * @param {Object} event .
     * @param {Object} event.payload .
     * @param {string} event.payload.locale .
     * @param {string} event.payload.country .
     * @param {Object[]} event.payload.countries .
     */loadCountriesSuccess:(a,b)=>{let{payload:{locale:c,country:d,countries:e}}=b;invariant(c&&d,"The LOAD_COUNTRIES_SUCCESS ("+LOAD_COUNTRIES_SUCCESS+") event must include valid `country` and `locale` in its payload.");const{countries:f,countriesLoaded:g}=a;f[d]||(f[d]={}),g[d]||(g[d]={}),f[d][c]=e,g[d][c]=!0;},/**
     * Dispatched when loading the countries fails.
     * @param {Object} state .
     * @param {Object} event .
     * @param {Object} event.payload .
     * @param {Error} event.payload.error .
     */loadCountriesError:(a,b)=>{let{payload:{error:c}}=b;const{error:d}=c;a.error=d,a.isError=!0;}}});const {loadCountriesSuccess,loadCountriesError}=countriesSlice.actions;var reducer = countriesSlice.reducer;

export { reducer as default, loadCountriesError, loadCountriesSuccess };
